// Reducer to handle all user's accounts

let initialState = {
  currentStep: 1,
  steps: [
    {id: 1, description: 'Loan Info'},
    {id: 2, description: 'Payment'},
    {id: 3, description: 'Review'}
  ]
}

function processSteps(state = initialState, action) {
  switch(action.type){
   case 'CHANGE_STEP':
      return {...state, currentStep: action.stepId};
    default:
      return state;
  }
}

export default processSteps;



// WEBPACK FOOTER //
// ./src/reducers/processSteps.js